export default __webpack_public_path__ + "static/avatar-kayi-common-0-e564db48c1fd82789adfdd8a2bb53c77.png";